import React, { useEffect } from 'react';
import useHelpStore from '../store/cmsStore/helpStore';
import Seo from '../components/Seo';

const Faq: React.FC = () => {
  const { faqs, fetchFAQ } = useHelpStore();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchFAQ();
  }, [fetchFAQ]);

  return (
    <>
        <Seo
          title="Frequently Asked Questions | SLAMMMM FAQ"
          description="Find quick answers to the most common questions about SLAMMMM — profiles, matching, safety, privacy, and billing — all in one place."
        />
   <section className="py-100 breadcrumb_section bg-light border-bottom">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="section_title text-center">
                        <h1 className="mb-0">Frequently Asked Questions</h1>
                    </div>
                </div>
            </div>
        </div>
    </section>
   <section className="pt-60 help_faq_section" id="faq">
        <div className="container">
            <div className="row g-3">
                <div className="col-md-4">
                    <div className="nav help_faq_nav_pills flex-column nav-pills me-xl-3" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                         {faqs.map((faq: any, index: number) => (
                            <button
                              className={`nav-link ${index === 0 ? 'active' : ''}`}
                              id={`v-pills-about-tab-${index}`}
                              data-bs-toggle="pill"
                              data-bs-target={`#v-pills-about-${index}`}
                              type="button"
                              role="tab"
                              aria-controls={`v-pills-about-${index}`}
                              aria-selected={index === 0 ? "true" : "false"}
                            >
                              {faq.faq} <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          ))}

                    </div>
                </div>
                <div className="col-md-8">
                    <div className="tab-content help_faq_tab_content" id="v-pills-tabContent">
                    {faqs.map((faq: any, index: number) => (
                            <div
                              key={index}
                              className={`tab-pane fade show ${index === 0 ? 'active' : ''}`}
                              id={`v-pills-about-${index}`}
                              role="tabpanel"
                              aria-labelledby={`v-pills-about-tab-${index}`}
                              tabIndex={0}
                            >
                              <div className="accordion" id={`accordion-${index}`}>

                                {faq.payload.map((item: any, itemIndex: number) => (
                                  <div className="accordion-item" key={itemIndex}>
                                    <h2 className="accordion-header">
                                      <button
                                        className={`accordion-button ${itemIndex >= 0 ? '' : 'collapsed'}`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse-${index}-${itemIndex}`}
                                        aria-expanded={itemIndex >= 0 ? "true" : "false"}
                                        aria-controls={`collapse-${index}-${itemIndex}`}
                                      >
                                        {item.question}
                                      </button>
                                    </h2>
                                    <div
                                      id={`collapse-${index}-${itemIndex}`}
                                      className={`accordion-collapse collapse ${itemIndex >= 0 ? 'show' : ''}`}
                                      data-bs-parent={`#accordion-${index}`}
                                    >
                                      <div className="accordion-body" dangerouslySetInnerHTML={{ __html: item.answer }}>

                                      </div>
                                    </div>
                                  </div>
                                ))}

                              </div>
                            </div>
                          ))}


                    </div>
                </div>
            </div>


        </div>
    </section>
    </>
  );
};

export default Faq;
